import { render } from "./ProjectBoard.vue?vue&type=template&id=a504afea&scoped=true"
import script from "./ProjectBoard.vue?vue&type=script&lang=js"
export * from "./ProjectBoard.vue?vue&type=script&lang=js"

import "./ProjectBoard.vue?vue&type=style&index=0&id=a504afea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a504afea"]])

export default __exports__